// /settings/letters — «Письма» (008, T024): письма установки и ответные письма с карточкой
// справа. Право — mail.read (администратор клиента и сопровождение). Поиск, статус, вид,
// сортировка и открытое письмо — в адресе страницы (?q=&state=&kind=&sort=&letter=): ссылку
// можно переслать, тост пробного письма открывает его карточку.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { LettersPage } from '../../../features/mail/LettersPage.tsx';
import { parseLettersSearch } from '../../../features/mail/search.ts';
import type { LettersSearch } from '../../../features/mail/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/letters')({
  validateSearch: parseLettersSearch,
  beforeLoad: requireSection('letters'),
  staticData: { crumb: 'Письма' },
  component: LettersRoute,
});

function LettersRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: LettersSearch) =>
      void navigate({ to: '/settings/letters', search: next, replace: true }),
    [navigate],
  );
  return <LettersPage search={search} onSearchChange={onSearchChange} />;
}
